<div class="service-bg from-top-pad">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h1>
                    <a href="#/account">{{'gen_my_account' | translate}}</a> / {{'gen_my_subscription' | translate}}
                </h1>
                <hr>
            </div>
        </div>



        <!-- Active Products -->
        <div class="row" *ngIf="activeProducts.length">
            <div class="col-12">
                <p>{{'gen_purchased_packages' | translate}}</p>
            </div>
        </div>
        <div class="row my-3" *ngFor="let product of activeProducts">
            <div class="col-8">
                <p class="sub-card p-3">
                    {{product.title}}

                    <!-- <span class="ml-3 badge bg-theme ng-binding">{{env.priceUnit + product.price}}</span> -->
                </p>
            </div>
            <div class="col-4 text-center">
                <!-- Subscribed -->
                <p class="sub-card p-3 cursor-po-c" *ngIf="!product.cancelled && product.autoRenew"
                    (click)="cancelSubscription(product)">
                    {{ "gen_cancel_subscription" | translate }}
                </p>

                <!-- Canceled -->
                <p class="sub-card p-3 text-warning" *ngIf="product.cancelled">
                    {{ "info_canceled_subscription" | translate }}{{product.expirationDate | momentPipe:'DD/MM/YYYY'}}
                </p>

                <!-- Non Autorenew -->
                <p class="sub-card p-3 text-warning" *ngIf="!product.autoRenew">
                    {{ "info_subscription_expiration" | translate }}{{product.expirationDate |
                    momentPipe:'DD/MM/YYYY'}}
                </p>
            </div>
        </div>

        <!-- Available Products -->
        <div class="row" *ngIf="availableProducts.length">
            <div class="col-12">
                <hr>
                <p>{{'gen_additional_products' | translate}}</p>
            </div>
        </div>

        <div class="row my-3" *ngFor="let product of availableProducts">
            <div class="col-8">
                <p class="sub-card p-3">
                    {{product.title}}
                    <span class="ml-3 badge bg-theme ng-binding">{{env.priceUnit + product.price}}</span>
                </p>
            </div>
            <div class="col-4 text-center">
                <p class="sub-card p-3 cursor-po-c" (click)="subscribe(product)">{{"gen_subscribe" | translate }}</p>
            </div>
        </div>
    </div>
</div>